import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators, UntypedFormArray } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { OpenDialogChooseImageFromClubComponent } from 'app/components/dialog/open-dialog-choose-image-from-club/open-dialog-choose-image-from-club.component';
import { CodeClub } from 'app/shared/models/class/club/club';
import { Licence } from 'app/shared/models/class/federation/federation';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { Parameter } from 'app/shared/models/class/parameter/parameter';
import { PracticePlace } from 'app/shared/models/class/practice-place/PracticePlace';
import { TagType, Tag } from 'app/shared/models/class/tags/tag';
import { Universe } from 'app/shared/models/class/universe/universe';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { FederationsService } from 'app/shared/services/federations/federations.service';
import { ImgOfferDefaultService } from 'app/shared/services/img-offer-default/img-offer-default.service';
import { OfferService } from 'app/shared/services/offer/offer.service';
import { ParametersService } from 'app/shared/services/parameters/parameters.service';
import { PracticePlaceService } from 'app/shared/services/practice-place/pratcice-place.service';
import { TagService } from 'app/shared/services/tag/tag.service';
import { TooltipService } from 'app/shared/services/tooltip/tooltip.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { UniverseService } from 'app/shared/services/universe/universe.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

const reader = new FileReader();

@Component({
  selector: 'app-admin-offer-edit-description',
  templateUrl: './admin-offer-edit-description.component.html',
  styleUrls: ['./admin-offer-edit-description.component.scss']
})
export class AdminOfferEditDescriptionComponent extends SubscriptionBaseComponent implements OnInit {
  @Input() mode: string;
  @Input() offer: FullOffer;
  @Input() tempoPricing: boolean;
  @Input() clubCode: string;
  @Input() form: FormGroup;
  @Input() userConnected: any;
  @Input() clubs: CodeClub[];
  @Input() universes: Universe[] = [];
  @Input() parameters: Parameter[] = [];
  @Input() practicesClub: PracticePlace[];
  @Input() licences: Licence[] = [];

  tags: TagType[];
  filteredTags: TagType[];

  @Output() offerPreviewUpdate = new EventEmitter<FullOffer>();
  @Output() imageUpdate = new EventEmitter<any>();
  @Output() editFinished = new EventEmitter<boolean>();
  @Output() fileUpdate = new EventEmitter<string>();

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  newOfferCheck: FullOffer;
  tempoPricingExist: boolean;
  isReturn = false;


  filteredOptions: Observable<string[]>;

  offerPreview = new FullOffer();
  file: any;


  tagsSelected: Tag[];
  tagsSelectedString: string[] = [];
  tagsSelectedSecondMainTag: Tag[];
  tagsSelectedThirdMainTag: Tag[];
  mainTags: Tag[] = [];



  isLoading = false;
  oldImage: string;


  filteredParameters: Parameter[] = [];

  color: ThemePalette = 'primary';
  universesSelected: Universe[] = [];

  typeOfInput: string[] = ['texte', 'date', 'heure', 'valeur min/max', 'liste', 'checkbox'];


  offerById: FullOffer;
  offerKey: any;

  parametersDefault = this.parametersService.numberOfParametersRequired;
  tooltipExternUrl: string;
  isExternalOffer: boolean = true;
  hasSessionUpdate = false;
  offerParameterUpdatable = true;
  isLoadingLicences = false;
  offerSessionSettable = true;

  maxFiftyLength = 50;


  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Informations',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],

    uploadUrl: 'v1/image',
    uploadWithCredentials: false,
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['insertImage', 'insertVideo'],
      ['fontSize']
    ]
  };

  constructor(
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private formBuilder: UntypedFormBuilder,
    private imgOfferDefault: ImgOfferDefaultService,
    private dialog: MatDialog,
    private tooltip: TooltipService,
    private offerService: OfferService,
    private faIconService: FaiconService,
    private uiService: UiService,
    private federationsSrv: FederationsService,
    private parametersService: ParametersService,
    private practicePlaceService: PracticePlaceService,
    private universeService: UniverseService,
    private tagsService: TagService,
    private parametersSrv: ParametersService

  ) {
    super()
  }

  ngOnInit(): void {
    if (this.offer)
      this.offerPreview = this.offer;
    else
      this.offerPreview = new FullOffer();

    this.initSub();
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
    this.subscription.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.isExternalOffer) {
      this.isExternalOffer = changes.isExternalOffer?.currentValue;
      changes.isExternalOffer?.currentValue ?
        this.f?.offerClubURL.setValidators([Validators.required]) :
        this.f?.offerClubURL.clearValidators();

      if (this.form) {
        this.f?.offerClubURL.updateValueAndValidity();
      }
    } else if (changes.hasSession) {
      this.hasSessionUpdate = changes.hasSession?.currentValue;
    }
  }

  private initSub(): void {
    this.prepareOfferToForm()

    this.subscription
      .add(
        this.dataService.tagSelectedAddOffer.subscribe({
          next: tagsSelected => {
            this.tagsSelected = tagsSelected;
            this.tagsSelectedString = [];
            this.tagsSelected?.forEach(t => this.tagsSelectedString.push(t.tagName));
            this.cdr.detectChanges();

            !tagsSelected?.length ?
              this.f.firstMainTag.disable() :
              this.f.firstMainTag.enable();
          }
        })
      )

      .add(
        this.parametersSrv.getParametersActive().subscribe((parametersFromSrv: Parameter[]) => {
          this.parameters = parametersFromSrv;
          this.filteredParameters = [...this.parameters];
        })
      )

    this.getUniverse();


    this.form.get('licenceRequired').valueChanges
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((value) => {
        if (value) {
          this.getLicencesByClub();
          this.form.get('licence').setValidators(Validators.required);
        } else {
          this.form.get('licence').reset();
          this.form.get('licence').clearValidators();
          this.form.get('licence').updateValueAndValidity();
        }
        this.form.get('licence').updateValueAndValidity();
      })

    this.form.get('clubCode').valueChanges
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((value) => {
        if (value && this.form.get('licenceRequired').value) {
          this.getLicencesByClub();
        }
      })

    if (this.offer?.licenceRequired) {
      this.getLicencesByClub();
    }

    //TODO a décommenter pour les mainTags
    if (this.offer?.mainTags) {
      this.filterMainTags('first', this.f?.firstMainTag);
      this.filterMainTags('second', this.f?.secondMainTag);
    }
  }

  getLicencesByClub(): void {
    let clubCode: string;
    switch (this.userConnected?.role) {
      case 'admin':
        clubCode = this.f.clubCode.value;
        break;

      case 'club':
        clubCode = this.userConnected.club_code;
        break;

      default:
        break;
    }

    if (clubCode?.length && this.f.licenceRequired.value) {
      this.isLoadingLicences = true;
      this.federationsSrv.getLicencesByClub(clubCode).subscribe({
        next: async licences => {

          if (this.mode === 'add' && licences?.length === 1) {
            setTimeout(() => this.f.licence.setValue(licences[0]));
          }

          this.licences = licences;
          const licenceToOffer = await licences?.find(pp => pp?.licenceKey === this.offer?.licenceKey);
          this.f.licence.setValue(licenceToOffer);

          this.isLoadingLicences = false;
        }
      });
    }
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  disabledToggle(): void {
    this.uiService.showSnackbar('Modification impossible: l\'offre est présente dans un panier ou a déjà été réservée');
  }

  private getUniverse(): void {
    this.universeService.getUniverse().subscribe({
      next: universes => {
        this.universes = universes;
        const gP = this.universes.find(u => u.universeKey === 1);

        if (this.offer && this.offer?.universes) {
          this.offer.universes.map(universe => {
            let univ = this.universes.find(u => u.universeKey === universe.universeKey);
            univ.checked = true;
            this.universesSelected.push(univ);
          })
        } else {
          gP.checked = true;
          this.universesSelected.push(gP);

          this.form.get('universes').setValue(this.universesSelected);
        }

        this.getTags();
      }
    });
  }

  filterMainTags(mainTag: string, { value }) {
    switch (mainTag) {
      case 'first':

        if (this.tagsSelected !== undefined) {
          this.tagsSelectedSecondMainTag = [... this.tagsSelected];
          const indexFirstTag = this.tagsSelectedSecondMainTag.findIndex(item => item.tagName === value);
          this.tagsSelectedSecondMainTag.splice(indexFirstTag, 1);
          this.tagsSelectedThirdMainTag = [...this.tagsSelectedSecondMainTag];

          if (this.f.secondMainTag.value) {
            if (value === this.f.secondMainTag.value) { this.f.secondMainTag.setValue(''); }
            if (value === this.f.thirdMainTag.value) { this.f.thirdMainTag.setValue(''); }
          }

        }
        break;

      case 'second':

        if (this.tagsSelectedSecondMainTag !== undefined) {
          this.tagsSelectedThirdMainTag = [...this.tagsSelectedSecondMainTag];

          const indexSecondtTag = this.tagsSelectedSecondMainTag.findIndex(item => item.tagName === value);
          this.tagsSelectedThirdMainTag.splice(indexSecondtTag, 1);

          if (value === this.f.firstMainTag.value) { this.f.firstMainTag.setValue(''); }
          if (value === this.f.thirdMainTag.value) { this.f.thirdMainTag.setValue(''); }
        }
        break;

      case 'third':
        if (this.f.secondMainTag.value) {
          if (value === this.f.firstMainTag.value) { this.f.firstMainTag.setValue(''); }
          if (value === this.f.secondMainTag.value) { this.f.secondMainTag.setValue(''); }
        }

        break;

      default:
        break;
    }
  }

  updatePreviewOffer(input: string, event?): void {
    this.offerPreview.clubCode = this.userConnected.role === 'club' ? this.userConnected.club_code : this.f.clubCode?.value;
    switch (input) {
      case 'offerName':
        this.offerPreview.offerName = this.f.offerName?.value;
        break;
      case 'description':
        this.offerPreview.description = this.f.description?.value;
        break;
      case 'duration':
        this.offerPreview.duration = this.f.duration?.value;
        break;
      case 'practicePlace':
        this.offerPreview.practicePlace = this.f.practicePlace?.value;
        break;
      case 'price':
        this.offerPreview.price = this.f.price?.value;
        break;
      case 'image':
        this.oldImage = this.offerPreview?.image ? JSON.parse(JSON.stringify(this.offerPreview?.image)) : '';
        const file = event?.target.files[0];

        const type = file.type?.split('/')[1];
        const limitSize = 300000;

        (['jpeg', 'png'].includes(type)) ?
          (file.size <= limitSize ?
            (reader.readAsDataURL(file),
              reader.onload = (res) => {
                this.file = file;
                this.fileUpdate.next(this.file);
                this.offerPreview.image = reader.result.toString() || this.imgOfferDefault.imgDefault;
                this.imageUpdate.next(reader.result.toString())
              }) :
            this.uiService.showSnackbar('la taille de l\'image de doit pas être suppérieure à 300kB')) :
          this.uiService.showSnackbar('Uniquement format jpg ou png');

        break;
      default:
        break;
    }

    this.offerPreview.hasSession = this.hasSessionUpdate;
    this.offerPreview.isExternalOffer = this.isExternalOffer;

    this.offerPreviewUpdate.next(this.offerPreview);
  }

  private getTags(): void {
    this.tagsService.getTags().subscribe({
      next: tags => {
        this.tags = tags?.slice().filter(category => category.tags.length > 0);
        this.tags.forEach(t => {
          t.tags.forEach(sbt => {
            sbt.completed = false;
          });
        });

        this.tags.forEach(t => {
          t.tags.forEach(sbt => {
            this.tagsSelected?.forEach(i => {
              if (i.tagKey === sbt.tagKey) {
                sbt.completed = true;
              }
            });
          });
        });

        this.filterTagsByUniverse();
      }
    });

  }


  addOrDeleteUniverse(universe: Universe): void {
    const isInUniversesSelected = this.universesSelected.findIndex(u => u.universeKey === universe.universeKey);

    isInUniversesSelected !== -1 ?
      this.universesSelected.splice(isInUniversesSelected, 1) :
      this.universesSelected.push(universe);

    this.form.get('universes').setValue(this.universesSelected),
      this.form.get('universes').updateValueAndValidity();

    this.filterTagsByUniverse();
  }

  filterTagsByUniverse() {
    if (this.universesSelected.length === 0) {
      this.tags.map(category => {
        category.completed = false;
        category.tags.map(tag => {
          tag.completed = false;
        })
      })
      this.filteredTags = [];
      this.tagsSelected = [];
      this.tagsSelectedSecondMainTag = [];
      this.tagsSelectedThirdMainTag = [];
      this.dataService.tagSelectedAddOffer.next([]);
    } else {
      this.filteredTags = [];
      [...this.tags].map(category => {
        this.universesSelected.map((universe, index) => {
          if (category.universes.some(universeCat => universeCat.universeKey === universe?.universeKey)) {
            if (!this.filteredTags.some(categoryTag => categoryTag.tagTypeKey === category.tagTypeKey)) {
              this.filteredTags.push(category);
            }
          }
        })
      })
    }
  }

  addParameter(oneParameter?) {
    let parameter = null;
    let isFirstPage = false;
    if (oneParameter) {
      this.parameters.map(oneParam => {
        if (oneParam.parameterKey === oneParameter.parameterKey) {
          parameter = oneParam;
          isFirstPage = oneParameter.isFirstPage;
        }
      })
    }

    let param = this.formBuilder.group({
      param: [parameter, Validators.required],
      isFirstPage: [{ value: isFirstPage, disabled: !this.offerParameterUpdatable }]
    });

    param.get('param').valueChanges.subscribe(result => {
      if (result) {
        let paramsSelected = [];
        this.form.getRawValue().parameters.map(oneSelected => {
          paramsSelected.push(oneSelected.param);
        })

        this.filteredParameters = [...this.parameters].filter((param) => !paramsSelected.includes(param));
      }
    })

    let paramsSelected = [];
    this.form.getRawValue().parameters.map(oneSelected => {
      paramsSelected.push(oneSelected.param);
    })

    this.filteredParameters = [...this.parameters].filter((param) => !paramsSelected.includes(param));

    this.getArray('parameters').push(param);
  }

  removeParameter(index: number): void {
    this.getArray('parameters').removeAt(index);
    let paramsSelected = [];
    this.form.getRawValue().parameters.map(oneSelected => {
      paramsSelected.push(oneSelected.param);
    })
    this.filteredParameters = [...this.parameters].filter((param) => !paramsSelected.includes(param));
  }

  get f() {
    return this.form?.controls;
  }

  get selectionParameters(): UntypedFormArray {
    return this.form.controls.parameters as UntypedFormArray;
  }

  get selectionParameterRequired(): UntypedFormArray {
    return this.form.controls.parameterRequired as UntypedFormArray;
  }

  getselectionParametersRequiredValues(index: number): UntypedFormArray {
    return this.selectionParameterRequired.controls[index]['controls'].values as UntypedFormArray;
  }

  getselectionParametersValues(index: number): UntypedFormArray {
    return this.selectionParameters.controls[index]['controls'].values as UntypedFormArray;
  }

  getPracticePlaceByClub(): void {
    let clubCode: string;

    switch (this.userConnected?.role) {
      case 'admin':
        clubCode = this.f.clubCode.value;
        break;

      case 'club':
        clubCode = this.userConnected.club_code;
        break;

      default:
        break;
    }

    if (!this.clubCode) {
      if (clubCode?.length) {

        this.practicePlaceService.getPracticePlaceByClub(clubCode).subscribe({
          next: async practiceClub => {

            if (this.mode === 'add' && practiceClub?.length === 1) {
              setTimeout(() => this.f.practicePlace.setValue(practiceClub[0]));
            }

            this.practicesClub = practiceClub;
            const practicePlaceToOffer = await practiceClub?.find(pp => pp?.practicePlaceKey === this.offerPreview?.practicePlaceKey);
            this.f.practicePlace.setValue(practicePlaceToOffer);
          }
        });
      }
    }
  }

  getTooltip(value: string): string {
    return this.tooltip.getTooltip(value);
  }

  private addMainTag(): void {
    const mainTagsNotFiltered = [];
    const firstMainTag = this.tagsSelected.find(t => t.tagName === this.f.firstMainTag.value);
    const secondMainTag = this.tagsSelected.find(t => t.tagName === this.f.secondMainTag.value);
    const thirdMainTag = this.tagsSelected.find(t => t.tagName === this.f.thirdMainTag.value);

    mainTagsNotFiltered.push(firstMainTag, secondMainTag, thirdMainTag);
    this.mainTags = mainTagsNotFiltered.filter(t => t !== undefined);
  }

  private prepareOfferToForm(): void {
    if (this.offer) {
      this.offerKey = this.offer.offerKey;
      const preOffer = new FullOffer();
      preOffer.tags = [];

      this.offerPreview = this.offer ? this.offer : preOffer;

      this.offerParameterUpdatable = this.offer.offerParameterUpdatable;

      if (this.offer?.parameters) {
        if (this.form.value?.parameters?.length > 0) {
          this.form.value.parameters.map((param, index) => {
            this.removeParameter(index);
            if (this.form.value.parameters.length === 0) {
              if (this.mode === 'edit') {
                this.offer.parameters.map((param, index) => {
                  this.addParameter(param);
                })
              }
            }
          })
        } else {
          if (this.mode === 'edit') {
            this.offer.parameters.map((param, index) => {
              this.addParameter(param);
            })
          }

        }
      }
    } else {
      this.mode !== 'add' ?
        this.dataService.tagSelectedAddOffer.next(this.offerPreview?.tags) :
        this.dataService.tagSelectedAddOffer.next([]);
    }
  }

  private saveImgOffer(offerKey: number, file: any, isMainPicture?: boolean): void {
    this.offerService.uploadImg(offerKey, [file], isMainPicture ? true : false).subscribe({
      next: () => { }
    });
  }

  getArray(array: string): UntypedFormArray {
    return this.form.get(array) as UntypedFormArray;
  }

  openDialogChooseImage() {
    // OpenDialogChooseImageFromClubComponent
    const dialogRef = this.dialog.open(OpenDialogChooseImageFromClubComponent, {
      data: { clubCode: this.f.clubCode.value },
      height: '85%',
      width: '80%',
    });

    dialogRef.afterClosed().subscribe({
      next: (res) => {
        if (res) {
          this.convertImageToFile(res);
        }
      }
    });
  }

  private convertImageToFile(offerKey: number) {
    this.offerService.getImgOffer(offerKey).subscribe({
      next: image => {
        this.file = this.dataURLtoFile(`data:image/png;base64, ${image.pictureBase64}`, `image_${offerKey}`);
        this.fileUpdate.next(this.file);
        reader.readAsDataURL(this.file),
          reader.onload = (res) => {
            this.imageUpdate.emit(reader.result.toString() || this.imgOfferDefault.imgDefault);
            this.offerPreview.image = reader.result.toString() || this.imgOfferDefault.imgDefault;
          }
      }
    });
  }

  dataURLtoFile(dataurl, filename) {

    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  getTooltipText(values, type): string {
    let valueConvert = [];

    const valuesSplit = values.split('#');
    switch (type) {
      case 'valeur min/max':
        valueConvert = [
          {
            name: 'Min:',
            value: valuesSplit[0]
          },
          {
            name: 'Max:',
            value: valuesSplit[1]
          },
        ];
        break;

      case 'liste':
        valueConvert = [];
        valuesSplit.forEach((v, index) => {
          const value = {
            name: ``,
            value: v
          };
          valueConvert.push(value);
        });

        break;

      case 'checkbox':
        valueConvert = [];
        valuesSplit.forEach((v, index) => {
          const value = {
            name: `Case ${index + 1}:`,
            value: v
          };
          valueConvert.push(value);
        });
        break;

      default:
        valueConvert = [];
        break;

    }

    let string = '';

    valueConvert.map((param, index) => {
      string += param.name + ' ' + param.value;

      if (index + 1 !== valueConvert.length) {
        string += ', '
      }
    })

    return string;
  }
}
